export interface HttpErrorLike {
	status: unknown;
	value: unknown;
}

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null;

export const isHttpErrorLike = (error: unknown): error is Error & HttpErrorLike =>
	error instanceof Error && "status" in error && "value" in error;

const describeHttpErrorValue = (value: unknown): string => {
	if (typeof value === "string") {
		return value;
	}
	if (value instanceof Error) {
		return value.message;
	}
	if (isRecord(value)) {
		const code = typeof value.code === "string" ? value.code : null;
		const message = typeof value.message === "string" ? value.message : null;
		if (code && message) {
			return `${code} ${message}`;
		}
		if (code ?? message) {
			return code ?? message ?? "";
		}
	}
	return JSON.stringify(value) ?? "";
};

export const describeHttpError = (error: Error & HttpErrorLike): string => {
	const description = describeHttpErrorValue(error.value);
	return `HTTP ${String(error.status)}: ${description || error.message}`;
};
